/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ElysConfig } from '../../models/elys-config';

export interface GetElysConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The Badgeur Uid.
 */
  badgeurUid: string;
}

export function getElysConfiguration(http: HttpClient, rootUrl: string, params: GetElysConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ElysConfig>>> {
  const rb = new RequestBuilder(rootUrl, getElysConfiguration.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('badgeurUid', params.badgeurUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ElysConfig>>;
    })
  );
}

getElysConfiguration.PATH = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys';
